<template>
  <FilterButton :title="title" @close="save()" :active="selected.length > 0" data-test="client-filter">
    <template #menu="{ close }">
      <div class="menu">
        <h4>Clients</h4>
        <div class="scroll-list">
          <label v-for="item in items" :key="item.text">
            <input type="checkbox" v-model="selected" :value="item.value" data-test="filter-item-client-checkbox"/>
            <span>{{ item.text }}</span>
          </label>
        </div>
        <div class="buttons">
          <v-btn size="small" variant="outlined" @click="clear" data-test="filter-client-clear">Clear</v-btn>
          <span>
            <v-btn class="mr8" variant="flat" size="small" color="secondary"
                   @click="selectAll" data-test="filter-client-select-all">Select All</v-btn>
            <v-btn size="small" variant="flat" color="primary" @click="close" data-test="filter-client-apply">Apply</v-btn>
          </span>
        </div>
      </div>
    </template>
  </FilterButton>
</template>

<script>
import FilterButton from '@/components/FilterButton';

export default {
  name: 'ClientFilter',
  components: { FilterButton },
  props: {
    value: Array,
    items: Array
  },
  data() {
    return {
      dirty: false,
      selected: []
    };
  },
  computed: {
    title() {
      if (this.selected.length === 1) {
        return this.selected[0];
      }
      return 'Clients';
    }
  },
  methods: {
    clear() {
      this.selected = [];
    },
    save() {
      if (this.dirty) {
        this.dirty = false;
        this.$emit('update:modelValue', this.selected)
      }
      return true;
    },
    selectAll() {
      this.selected = this.items.map(x => x.value);
    }
  },
  watch: {
    selected() {
      this.dirty = true;
      this.$emit('input', this.selected);
    }
  }
};
</script>

<style scoped>
.mr8 {
  margin-right: 8px;
}

.menu {
  padding: 1rem 0 0 0;
  min-width: 500px;
}

.menu > h4 {
  padding: 0 1rem;
}

.scroll-list {
  max-height: 300px;
  overflow-y: scroll;
  margin: 0.5rem 1rem 1rem;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-column-gap: 4rem;
  border: 1px solid var(--v-border-base);
  padding: 0.5rem;
}

.scroll-list > label {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  align-items: center;
  align-content: center;
  padding: 0.2rem 0;
  cursor: pointer;
  user-select: none;
}

.menu > .buttons {
  padding: 1rem;
  border-top: 1px solid var(--v-border-base);
  background: var(--v-gray-lighten5);
  display: flex;
  justify-content: space-between;
}
</style>
